import React from 'react';
import { Link } from 'react-router-dom';

// Glossy circular "orb" CTA that links to the vitamin test.
// Live HTML/CSS (not an image): crisp on any screen, light, brand green→blue glow.
const ORB_CSS = `
@keyframes orbSpin { to { transform: rotate(360deg); } }
@keyframes orbBeat { 0%,100% { opacity:.55 } 50% { opacity:1 } }
.orb { width: min(300px, 78vw); }
.orb__ring {
  position:absolute; inset:-2px; border-radius:9999px;
  background: conic-gradient(from 210deg, #2f9e44, #37d67a, #1c7ed6, #2f9e44);
  filter: blur(9px); opacity:.85;
  animation: orbSpin 7s linear infinite;
}
.orb__edge {
  position:absolute; inset:-2px; border-radius:9999px;
  background: conic-gradient(from 210deg, #35c46a, #1c7ed6, #35c46a);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2px));
          mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 2px));
  animation: orbSpin 7s linear infinite;
}
.orb:hover .orb__ring { opacity:1; filter: blur(12px); }
.orb__beat { animation: orbBeat 1.8s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) {
  .orb__ring, .orb__edge, .orb__beat { animation: none; }
}
`;

const VitaminTestOrb = ({ className = '' }) => (
  <Link to="/vitamin-test" aria-label="Пройти безкоштовний тест на дефіцит вітамінів"
    className={`orb group relative aspect-square rounded-full block select-none transition-transform duration-300 hover:-translate-y-1 ${className}`}>
    <style>{ORB_CSS}</style>
    <span className="orb__ring" aria-hidden />
    <span className="orb__edge" aria-hidden />
    {/* dark glossy body */}
    <span className="absolute inset-0 rounded-full" aria-hidden
      style={{ background: 'radial-gradient(120% 120% at 50% 22%, #17304d 0%, #0a1420 45%, #04070c 100%)' }} />
    {/* top gloss highlight */}
    <span className="absolute inset-0 rounded-full overflow-hidden" aria-hidden>
      <span className="absolute -top-1/4 left-1/2 -translate-x-1/2 w-[120%] h-1/2 rounded-full"
        style={{ background: 'linear-gradient(to bottom, rgba(255,255,255,.22), rgba(255,255,255,0))' }} />
    </span>

    {/* content */}
    <span className="relative z-10 flex h-full flex-col items-center justify-center text-center px-[14%]">
      <img src="/logo-ondark.svg" alt="MSA" width="150" height="46"
        className="w-[46%] h-auto mb-[7%]" />
      <span className="font-display font-bold leading-[1.05] text-white" style={{ fontSize: 'clamp(15px, 5.4vw, 26px)' }}>
        Пройти безкоштовний
      </span>
      <span className="font-display font-bold leading-[1.05] mt-1" style={{ fontSize: 'clamp(15px, 5.4vw, 26px)', color: '#37d67a' }}>
        тест на дефіцит вітамінів
      </span>
      {/* heartbeat */}
      <svg className="orb__beat mt-[8%] w-[42%]" viewBox="0 0 120 24" fill="none" aria-hidden>
        <path d="M2 12h22l6-8 8 16 6-12 5 8h20l6-6 6 6h26" stroke="#37d67a" strokeWidth="2.4"
          strokeLinecap="round" strokeLinejoin="round" />
        <path d="M60 4l1.6 4.4L66 10l-4.4 1.6L60 16l-1.6-4.4L54 10l4.4-1.6z" fill="#37d67a" />
      </svg>
    </span>
  </Link>
);

export default VitaminTestOrb;
